module.exports = __webpack_public_path__ + "assets/img/photo_tooth_all.ea188e95.png";